import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  REAL_ESTATE_PAGE_IMAGE_FOUR,
  REAL_ESTATE_PAGE_IMAGE_ONE,
  REAL_ESTATE_PAGE_IMAGE_THREE,
  REAL_ESTATE_PAGE_IMAGE_TWO,
  REAL_ESTATE_PAGE_IMAGE_FIVE,
} from "../utils/constants"

const RealEstate = () => {
  const leftColumnData = [
    {
      title: "Property Development",
      desc: "We design and deliver premium residential towers, commercial offices, retail hubs, and mixed-use projects in Dubai’s prime locations, creating sustainable, smart communities that add long-term value for investors and residents.",
      imgPath: REAL_ESTATE_PAGE_IMAGE_ONE,
    },
    {
      title: "Real Estate Investment",
      desc: "Our investment expertise ensures strategic acquisitions that maximize returns and capital appreciation, backed by Morifar Group’s financial strength and focused on prime Dubai locations and select international markets.",
      imgPath: REAL_ESTATE_PAGE_IMAGE_TWO,
    },
  ]

  const rightColumnData = [
    {
      title: "Property Management",
      desc: "We offer full-service property management, including leasing, maintenance, tenant relations, and rental solutions, ensuring sustained occupancy, enhanced asset value, and consistent returns for investors, homeowners, and corporate clients.",
      imgPath: REAL_ESTATE_PAGE_IMAGE_THREE,
    },
    {
      title: "Real Estate Advisory",
      desc: "Our advisory services provide market insights, valuations, and investment structuring, helping clients and partners make informed decisions, optimize portfolios, and unlock profitable opportunities in Dubai and international real estate markets.",
      imgPath: REAL_ESTATE_PAGE_IMAGE_FOUR,
    },
    {
      title: "Joint Ventures & Partnerships",
      desc: "We collaborate with leading developers, investors, and institutions to create landmark projects, leveraging Morifar Group’s strong capital base and strategic expertise to deliver iconic developments across Dubai and beyond.",
      imgPath: REAL_ESTATE_PAGE_IMAGE_FIVE,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default RealEstate
